// client/src/App.js

import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import Container from 'react-bootstrap/Container';

import authService from './services/authService';

// --- IMPORTS DES COMPOSANTS ---
import Sidebar from './components/Sidebar';

// --- IMPORTS DES PAGES ---
import Login from './pages/Login';

// Pages principales
import Dashboard from './pages/Dashboard';
import Accounts from './pages/Accounts';
import Categories from './pages/Categories';
import Analytics from './pages/Analytics';
import Settings from './pages/Settings';
import Investments from './pages/Investments';

// Pages de la section "Relevés Bancaires"
import BankStatements from './pages/bank-statements/BankStatements';
import Import from './pages/bank-statements/Import';
import ManageStatements from './pages/bank-statements/ManageStatements';
import Transactions from './pages/bank-statements/Transactions';

// Pages de la section "Investissements"
import InvestmentsOverview from './pages/investments/InvestmentsOverview';
import Pea from './pages/investments/Pea';
import Crypto from './pages/investments/Crypto';

// Pages de la section "CS:GO"
import Csgo from './pages/csgo/Csgo';
import CsgoOverview from './pages/csgo/CsgoOverview';
import Items from './pages/csgo/Items';
import Imports from './pages/csgo/Imports';
import Gambling from './pages/csgo/Gambling';

// Pages de la section "Documents"
import Documents from './pages/documents/Documents';
import DocumentsList from './pages/documents/DocumentsList';

// Layout protégé : vérifie le token, affiche la Sidebar + le contenu
function ProtectedLayout() {
  if (!authService.isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="d-flex">
      <Sidebar />
      <main className="flex-grow-1" style={{ marginLeft: '250px', minHeight: '100vh' }}>
        <Container fluid className="p-4 p-lg-5" style={{ maxWidth: '1600px' }}>
          <Outlet />
        </Container>
      </main>
    </div>
  );
}

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        {/* Route publique */}
        <Route path="/login" element={<Login />} />

        {/* Toutes les routes applicatives sont protégées */}
        <Route element={<ProtectedLayout />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/bank-statements" element={<BankStatements />}>
            <Route index element={<Navigate to="analyse" replace />} />
            <Route path="analyse" element={<Analytics />} />
            <Route path="transactions" element={<Transactions />} />
            <Route path="comptes" element={<Accounts />} />
            <Route path="import" element={<Import />} />
            <Route path="categories" element={<Categories />} />
            <Route path="manage" element={<ManageStatements />} />
          </Route>
          <Route path="/investments" element={<Investments />}>
            <Route index element={<Navigate to="overview" replace />} />
            <Route path="overview" element={<InvestmentsOverview />} />
            <Route path="pea" element={<Pea />} />
            <Route path="crypto" element={<Crypto />} />
            {/* Anciens onglets ETF/Transactions retirés avec le module d'origine */}
            <Route path="etf" element={<Navigate to="/investments/pea" replace />} />
            <Route path="transactions" element={<Navigate to="/investments/pea" replace />} />
          </Route>
          <Route path="/csgo" element={<Csgo />}>
            <Route index element={<Navigate to="overview" replace />} />
            <Route path="overview" element={<CsgoOverview />} />
            <Route path="items" element={<Items />} />
            <Route path="imports" element={<Imports />} />
            <Route path="gambling" element={<Gambling />} />
          </Route>
          <Route path="/documents" element={<Documents />}>
            <Route index element={<Navigate to="tous" replace />} />
            <Route path="tous" element={<DocumentsList category={null} />} />
            <Route path="fiches-de-paie" element={<DocumentsList category="PAYSLIP" />} />
            <Route path="releves-bancaires" element={<DocumentsList category="BANK_STATEMENT" />} />
            <Route path="autres" element={<DocumentsList category="OTHER" />} />
          </Route>
          {/* Ancienne URL : Comptes vit désormais dans le hub Dépenses */}
          <Route path="/accounts" element={<Navigate to="/bank-statements/comptes" replace />} />
          <Route path="/settings" element={<Settings />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
